import axios from 'axios';
import { Catalog } from './search-catalog';
const apiUrl = process.env.BACKEND_URL;

export interface IDepartment {
  id: string;
  active: boolean;
  name: string;
  shortName: string;
  mission: string;
  vision: string;
  values: string;
  hidden: boolean;
  link?: string;
  description?: string;
  location?: string;
  phone1?: string;
  assignments?: string;
  slug: string;
  externalId?: string;
}

export interface IDepartmentSectionType {
  id: string;
  title: string;
  active: boolean;
  external_id: number;
  created_at: string;
  updated_at: string;
}

export interface ISection {
  id: string;
  name: string;
  address: string;
  postalCode: string;
  district: string;
  city: string;
  state: string;
  countryCode: string;
  active: boolean;
  openingTime: string;
  mapUrl: string;
  complement?: string;
  externalId?: string;
  contact?: string;
  departmentSectionType?: IDepartmentSectionType;
  department?: {
    id: string;
    slug: string;
    name: string;
    shortName: string;
    active: boolean;
  };
}

export interface IDepartmentSectionsResponse {
  departmentSections: ISection[];
  metadata: {
    limit: number;
    offset: number;
    total: number;
  };
}

export async function getDepartments(): Promise<IDepartment[]> {
  const response = await axios.get(`${apiUrl}/v1/department`);

  return response.data;
}
export async function getSection(departmentId?: string): Promise<ISection[]> {
  const response = await axios.get(
    `${apiUrl}/v1/department/${departmentId}/section`
  );

  return response.data;
}
export interface DepartmentSectionsParams {
  departmentSectionTypeId?: string;
  city?: string;
  limit?: number;
  offset?: number;
  distinctBy?: Array<DepartmentSectionDistinctBy>;
  resolveSharedReferences?: boolean;
  orderBy?: string;
}

export enum DepartmentSectionDistinctBy {
  ID = "id",
  NAME = "name",
  ADDRESS = "address",
  POSTAL_CODE = "postalCode",
  DISTRICT = "district",
  COMPLEMENT = "complement",
  CITY = "city",
  STATE = "state",
  COUNTRY_CODE = "countryCode",
  OPENING_TIME = "openingTime",
  MAP_URL = "mapUrl",
  EXTERNAL_ID = "externalId",
  ACTIVE = "active",
  SHARED_DEPARTMENT_SECTION_EXTERNAL_ID = "sharedDepartmentSectionExternalId",
  SHARED_DEPARTMENT_SECTION_ID = "sharedDepartmentSectionId",
}

export async function getDepartmentSections(
  params: DepartmentSectionsParams
): Promise<IDepartmentSectionsResponse> {
  const response = await axios.get<IDepartmentSectionsResponse>(
    `${apiUrl}/v1/department-section`,
    { params }
  );

  return response.data;
}

export interface DepartmentSectionCitiesParams {
  status: 'active' | 'inactive';
}

export async function getDepartmentSectionCities(
  params: DepartmentSectionCitiesParams
): Promise<string[]> {
  const response = await axios.get<string[]>(
    `${apiUrl}/v1/department-section/cities`,
    { params }
  );

  return response.data;
}

export interface DepartmentSectionTypeByExternalIdsParams {
  externalIds: number[];
}

export async function getDepartmentSectionTypeByExternalIds(
  params: DepartmentSectionTypeByExternalIdsParams
): Promise<IDepartmentSectionType[]> {
  const response = await axios.post<IDepartmentSectionType[]>(
    `${apiUrl}/v1/department-section-type/search-by-external-ids`,
    params
  );

  return response.data;
}

export async function getSectionCatalog(
  departmentId?: string,
  sectionId?: string
): Promise<Catalog[]> {
  const response = await axios.get(
    `${apiUrl}/v1/department/${departmentId}/section/${sectionId}/catalogs`
  );
  return response.data;
}

export async function getDepartmentSectionById(
  departmentSectionId: string
): Promise<ISection> {
  const response = await axios.get(
    `${apiUrl}/v1/department-section/${departmentSectionId}`
  );

  return response.data;
}
